import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import CompraStatusReducer from '../compraStatus/compraStatusReducer';
import CompraCategoriaReducer from '../compraCategoria/compraCategoriaReducer';
import CompraTipoReducer from '../compraTipo/compraTipoReducer';
import PrioridadeReducer from '../prioridade/prioridadeReducer';
import FormaPagamentoReducer from '../formaPagamento/formaPagamentoReducer';
import ClienteReducer from '../cliente/clienteReducer';
import FornecedorReducer from '../fornecedor/fornecedorReducer';
import TransportadoraReducer from '../transportadora/transportadoraReducer';
import ProdutoReducer from '../produto/produtoReducer';
import SolicitacaoCompraReducer from '../solicitacaoCompra/solicitacaoCompraReducer';
import PedidoReducer from '../pedido/pedidoReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	dashboard: DashboardReducer,
	usuario: UsuarioReducer,
	compraStatus: CompraStatusReducer,
	compraCategoria: CompraCategoriaReducer,
	compraTipo: CompraTipoReducer,
	prioridade: PrioridadeReducer,
	formaPagamento: FormaPagamentoReducer,
	cliente: ClienteReducer,
	fornecedor: FornecedorReducer,
	transportadora: TransportadoraReducer,
	produto: ProdutoReducer,
	solicitacaoCompra: SolicitacaoCompraReducer,
	pedido: PedidoReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;

